export default __webpack_public_path__ + "static/media/header.d746ea21.png";